import Vue from "vue";
import Router from "vue-router";
import routes from "./routes";
import store from "@/store";

Vue.use(Router);

export default new Router({
  routes: routes.map(route => ({
    name: route.name,
    path: route.path,
    component: route.component,
    beforeEnter: (to, from, next) => {
      document.title = route.title;

      //store.dispatch("common/updateTitle", route.title);
      //store.dispatch("common/updateLayout", route.layout);

      next();
    }
  }))
});
